<template>
  <div>
    <template v-if="1 === step">
      <register-step-first @validated="validated" :try-register-data="tryRegisterData"/>
    </template>

    <template v-if="2 === step">
      <register-step-second @validated="validated"/>
    </template>

    <template v-if="3 === step">
      <register-step-third
          :default-email="data.email"
          :default-fname="data.fname"
          :default-lname="data.lname"
          @validated="validated"
      />
    </template>

    <template v-if="4 === step">
      <register-step-fourth @validated="validated"/>
    </template>
  </div>
</template>

<script>
import RegisterStepFirst from '@/components/header/auth/Steps/RegisterStepFirst.vue';
import RegisterStepSecond from '@/components/header/auth/Steps/RegisterStepSecond.vue';
import RegisterStepThird from '@/components/header/auth/Steps/RegisterStepThird.vue';
import RegisterStepFourth from '@/components/header/auth/Steps/RegisterStepFourth.vue';
import {mapActions} from 'vuex';
import {socialLogin} from '@/mixins/auth/socialLogin';

export default {
  name: 'register-step',
  components: {RegisterStepFirst, RegisterStepSecond, RegisterStepThird, RegisterStepFourth},
  mixins: [socialLogin],
  props: ['tryRegisterData'],
  data() {
    return {
      data: {
        provider: 'email',
      },
      step: 1,
    }
  },
  computed: {
    registerUri() {
      switch (this.data.provider) {
        case 'email':
          return 'register'

        default:
          return `register/social/${this.data.provider}`
      }
    },
  },
  methods: {
    ...mapActions('loader', [
      'SET_LOADER',
    ]),
    ...mapActions('auth', [
      'UPDATE_TOKEN',
      'FETCH_USER',
    ]),
    validated(formData) {
      if (cookies.get('invited_by')) {
        this.data.invited_by = cookies.get('invited_by');
      }

      this.data = _.assign({}, _.merge(this.data, formData));
      if (4 > this.step) {
        this.step++;
        return;
      }
      this.storeUser(this.data);
    },
    storeUser(formData) {
      this.SET_LOADER(true);
      this.$http.post(this.registerUri, formData).then((response) => {
        this.SET_LOADER(false);

        this.$dialogs.changeTab('auth', 'registered');

        if (this.data.provider === 'email') {
          // To use this for GTM
          cookies.set('registered_email', formData.email, '7d');
          window.open(this.$router.resolve({name: 'login'}).href + '#verification', '_self');
        } else {
          console.log('Event "nieuw_lid" for new user "' + formData.email + '"');
          window.dataLayer?.push({
            'event': 'nieuw_lid',
            'email': formData.email
          });

          setTimeout(() => {
            this.getUserByToken(response.data.data.token);
          }, 1500)
        }
      });
    }
  }
}
</script>
